module.exports = __webpack_public_path__ + "static/media/choiceqr.3c2e69de.png";